/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-17 13:50
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 视频清晰度
  */
 let EnmuVideoQuality = {
    "高清": 						new EnumItem('高清', 1),
    "流畅": 						new EnumItem('流畅', 2),
    ...enumMixn
 }
 export default EnmuVideoQuality
 